import { render, staticRenderFns } from "./InfoPricedValue.vue?vue&type=template&id=3a96493a&scoped=true"
import script from "./InfoPricedValue.vue?vue&type=script&lang=js"
export * from "./InfoPricedValue.vue?vue&type=script&lang=js"
import style0 from "./InfoPricedValue.vue?vue&type=style&index=0&id=3a96493a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a96493a",
  null
  
)

export default component.exports